import { checkLinkForExpiryBasedOnID } from "api/configuration";
import { fetchWorkflowInfoById } from "api/dashboardDetail";
import { fetchWorkflow } from "api/formDisplay";
import {
  getSupportingDocumentsConfig,
  uploadSupportingDocuments,
} from "api/supportingDocuments";
import { validate } from "components/DynamicForm/validate";
import FormButton from "components/FormButton";
import Layout from "components/Layout";
import { Group } from "lib";
import LoadingSpinner from "lib/LoadingSpinner";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setConfigLoading } from "redux/configurationReducer";
import { setSelectedData } from "redux/formDisplay";
import { resetConfigState } from "redux/requestedSupportingDocs";
import { dynamicFormScroll } from "utils";
import { cleardeleteDocument } from "redux/uploadDocumentReducer";
import { encrypt } from "helper/encryptDecrypt";
const SupportingDocuments = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const supportingDocumentsConfig = useSelector(
    (state) => state?.requestedSupportingDocs?.supportingDocumentsConfig
  );
  const configLoading = useSelector(
    (state) => state?.requestedSupportingDocs?.configLoading
  );
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  const [userData, setUserData] = useState(null);
  const [organisationNameDIFC, setOrganisationNameDIFC] = useState("");
  const uploadedRequestedDocs = useSelector(
    (state) => state?.uploadDocumentReducer?.uploadedDocument
  );

  const supportingDocumentsUploadedSuccess = useSelector(
    (state) =>
      state?.requestedSupportingDocs?.supportingDocumentsUploadedSuccess
  );

    const updateRequestedArray = useSelector(
    (state) => state?.requestedSupportingDocs?.updateRequestedArray
  );

    const deleteDocument = useSelector((state)=> state?.uploadDocumentReducer?.deleteDocument)

  const [formErr, setFormErr] = useState({});
  const stateErrRef = useRef();
  stateErrRef.current = { ...formErr };
  const search = window.location.search;
  const query = new URLSearchParams(search);

  const trigger = React.useMemo(() => {
    //optimization
    return query.get("trigger");
  }, [search,query]);

  useEffect(() => {
    if (decryptedId?.requestId) {
      dispatch(resetConfigState());
      dispatch(getSupportingDocumentsConfig(decryptedId.requestId));
    }
    if (decryptedId?.subWfId) {
      dispatch(fetchWorkflow(decryptedId?.subWfId));
    }
    if (decryptedId?.primaryWorkflowId) {
      dispatch(fetchWorkflowInfoById(decryptedId?.primaryWorkflowId))
        .unwrap()
        .then((res) => {
          const userDataInSubWF = res?.source_data?.subworkflows.find(
            (item) => item?._id === decryptedId?.subWfId
          );
          const orgNme = res?.source_data?.applicant_sequence_id;
          const isDIFC = orgNme?.includes("DIFC");
          setOrganisationNameDIFC(isDIFC);
          setUserData(userDataInSubWF);
          dispatch(setConfigLoading(false));
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decryptedId]);

  useEffect(() => {
    const fetchData = async() =>{
    if (updateRequestedArray?.length > 0) {
      let hasUserAlreadyUploadedSupportingDocs = false;
      updateRequestedArray.forEach((item) => {
        item.requestedId === decryptedId?.requestId &&
          item.is_addressed === true &&
          (hasUserAlreadyUploadedSupportingDocs = true);
      });
      if (hasUserAlreadyUploadedSupportingDocs) {

        const stateData = {
          content_trigger:{
          trigger :"AlreadyUploadedSupportingDocs"
          },
          organisation_id:selectedData?.organisation_id
        };
        let encryptedData =  await encrypt(stateData)
          sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
          navigate("/update-successful");
      }
    }
  }
  fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateRequestedArray]);

  const selectedData = useSelector((state) => state.formData?.selectedData);

  // sections = {},
  let formSkeleton = {};
  let formStructure = {};
  if (
    supportingDocumentsConfig &&
    Object.keys(supportingDocumentsConfig)?.length
  ) {
    supportingDocumentsConfig?.wf_journey?.map((item, index) => {
      formStructure = { ...item?.form_structure };
    });

    formSkeleton = formStructure?.sections;
  }

  const clearFieldError = (fields, isList) => {
    if (typeof fields !== "string" && !Array.isArray(fields)) {
      throw new Error("fields should be string or an array of strings");
    }
    fields = isList ? fields : [fields];
    let err = { ...stateErrRef.current };

    fields.forEach((field) => {
      if (err[field] !== undefined) {
        err = Object.assign({}, err, { [field]: undefined });
      }
    });
    setFormErr(err);
  };

  const handleSubmitUploadedeDocs = async() => {
    let errors = {};
    let validateFields = formSkeleton?.[0]?.form_groups?.[0]?.form_elements;
    validateFields = validateFields?.slice(1); // as first field is sub-header
    errors = await validate(validateFields, selectedData, dispatch);
    if (Object.keys(errors).length > 0) {
      setFormErr(errors);
      dynamicFormScroll();
      return;
    }

    const newObject = Object.keys(uploadedRequestedDocs).reduce((acc, key) => {
      acc[uploadedRequestedDocs[key].field_label] = uploadedRequestedDocs[key];
      return acc;
    }, {});

    const matchedRequestId = updateRequestedArray?.find(
      (item) => item?.requestedId === decryptedId?.requestId
    );

    const obj = {
      params: {
        requestId: decryptedId?.requestId,
        organisationId: decryptedId?.organisationId,
        subWfId: decryptedId?.subWfId,
      },
      body: {
        uploadedDocument: newObject,
        userName: userData?.full_name,
        userEmail: userData?.email,
        workFlowId: decryptedId?.primaryWorkflowId,
        createdBy: matchedRequestId?.createdBy
          ? matchedRequestId?.createdBy
          : userData?.createdBy
          ? userData?.createdBy
          : userData?.user_id,
          deleteDocument:deleteDocument
      },
    };
    if (obj?.body?.userEmail && obj?.body?.userName) {
      dispatch(uploadSupportingDocuments(obj));
      dispatch(cleardeleteDocument())
    }
  };

  useEffect(() => {
    const fetchData = async() =>{
    if (supportingDocumentsUploadedSuccess) {
      dispatch(resetConfigState());
      const stateData = {
        content_trigger:{
        trigger:trigger
      },
        organisation_id:selectedData?.organisation_id
      };
      let encryptedData = await  encrypt(stateData)
        sessionStorage.setItem("stateData", JSON.stringify(encryptedData));
      navigate("/update-successful");
    }
  }
  fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supportingDocumentsUploadedSuccess]);

  if (!userData || configLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <Layout
        // landing={true}
        removeLeftMargin={true}
        // organisationNameDIFC={organisationNameDIFC}
        banner={formStructure?.layout}
      >
        {formSkeleton?.[0]?.form_groups.map((item, index) => {
          return (
            <Fragment key={index}>
              <Group
                formErr={formErr}
                formFields={item?.form_elements}
                className={"client_detail_group"}
                selectedData={selectedData}
                setSelectedData={setSelectedData}
                clearFieldError={clearFieldError}
              />
              <FormButton
                formButtons={item?.form_buttons}
                handleSubmitUploadedeDocs={handleSubmitUploadedeDocs}
              />
            </Fragment>
          );
        })}
      </Layout>
    </div>
  );
};

export default SupportingDocuments;
